// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"F-f","link":"F-ch","cens":"F-z5"};